import { useEffect, useState } from 'react';
import { TabbedForm, useAuthProvider, RecordContextProvider } from 'react-admin';
import { UserType } from 'src/auth/types';

import { Container } from '@mui/material';

import { tabbedContainerStyles } from 'src/styles';
import EmployeeGeneralTab from '../Employees/EmployeeShow/EmployeeGeneralTab';
import EmployeeTopToolbar from '../Employees/EmployeeTopToolbar';

const Profile = () => {
    const { getIdentity, getEducationCenterId } = useAuthProvider();

    const [profile, setProfile] = useState<UserType>();
    const [isInactiveEmployee, setIsInactiveEmployee] = useState<boolean>(false);

    useEffect(() => {
        getIdentity?.().then((profile) => {
            setProfile(profile as UserType);
        });
    }, [getIdentity]);

    let selectedCenterId: number | undefined = getEducationCenterId();
    if (selectedCenterId === undefined) {
        if (profile?.employees?.length) {
            selectedCenterId = profile.employees[0].educationCenterId || undefined;
        }
    }

    if (!profile) {
        return null;
    }

    return (
        <>
            <Container maxWidth={false} sx={tabbedContainerStyles}>
                <RecordContextProvider value={profile}>
                    <div className="show-page-container">
                        <EmployeeTopToolbar
                            selectedCenterId={selectedCenterId}
                            isUserProfile={true}
                            onInactiveComputed={setIsInactiveEmployee}
                        />
                        <TabbedForm toolbar={false}>
                            <TabbedForm.Tab label="Загальна інформація">
                                <EmployeeGeneralTab
                                    selectedCenterId={selectedCenterId ? selectedCenterId.toString() : ''}
                                    isUserProfile={true}
                                    isInactiveEmployee={isInactiveEmployee}
                                />
                            </TabbedForm.Tab>
                        </TabbedForm>
                    </div>
                </RecordContextProvider>
            </Container>
        </>
    );
};

export default Profile;
